// extracted by mini-css-extract-plugin
export default {"contactList__mainContainer":"ContactList_contactList__mainContainer__U+-hz","contactList__buttonContainer":"ContactList_contactList__buttonContainer__ZbMJ7"};